
export const ETHERS_STARTEGY = 'ethers'
